export const capitalizeFirstLetter = (string) => {
  if (typeof string !== 'string') return '';
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const sortArrayOfObjects = (array, key, typeOfKey, order) => {
  let asc = -1;
  let desc = 1;
  if (order === 'desc' || order === 'descending') {
    asc = 1;
    desc = -1;
  }
  array.sort((a, b) => {
    let val1 = a[key];
    let val2 = b[key];
    if (typeOfKey === 'number') {
      val1 = Number(a[key]);
      val2 = Number(b[key]);
    }

    if (val1 < val2) {
      return asc;
    }
    if (val1 > val2) {
      return desc;
    }
    return 0;
  });

  return array;
};
